module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('avatar', {
    attrs: {
      "user": _vm.user
    },
    on: {
      "onUpdateAvatar": _vm.updateAvatar
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 block-personal-info-left"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "title2 pull-left"
  }, [_vm._v("THÔNG TIN CÁ NHÂN")]), _c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": require("../../assets/images/faces/ic_edit.svg")
    },
    on: {
      "click": _vm.updateProfile
    }
  }), _c('div', {
    staticClass: "clearfix"
  }), _c('UserInfo', {
    attrs: {
      "user": _vm.user
    }
  }), _c('Follow', {
    attrs: {
      "following": _vm.following,
      "followed": _vm.followed
    }
  }), _c('div', {
    staticClass: "clearfix"
  })], 1)]), _c('div', {
    staticClass: "card block-activity"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "title2"
  }, [_vm._v("HOẠT ĐỘNG GẦN ĐÂY")]), _c('div', {
    staticClass: "clearfix"
  }), _c('Activity', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])]), _c('div', {
    staticClass: "col-md-5 block-personal-info-right"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "title2"
  }, [_vm._v("THÀNH TÍCH")]), _c('div', {
    staticClass: "clearfix"
  }), _c('Achieve', {
    attrs: {
      "user": _vm.user
    }
  }), _c('br'), _c('h6', {
    staticClass: "title2 pull-left"
  }, [_vm._v("THÀNH TÍCH NỔI BẬT")]), _c('p', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "link-color",
    on: {
      "click": function($event) {
        return _vm.routePathAchievement()
      }
    }
  }, [_vm._v("Quản lý thành tích >")])]), _c('div', {
    staticClass: "clearfix"
  }), _c('Highlight', {
    attrs: {
      "user": _vm.user
    }
  }), _c('h6', {
    staticClass: "title2 pull-left"
  }, [_vm._v("MÔN HỌC "), (_vm.user.type_user === 1 || _vm.user.type_user === 3) ? _c('span', [_vm._v("THẾ MẠNH")]) : (_vm.user.type_user === 2) ? _c('span', [_vm._v("CÓ THỂ GIẢNG DẠY")]) : _vm._e()]), _c('p', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "link-color",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Quản lý đăng ký "), (_vm.user.type_user === 1 || _vm.user.type_user === 3) ? _c('span', [_vm._v("PRO")]) : _vm._e(), _c('span', [_vm._v(" >")])])]), _c('div', {
    staticClass: "clearfix"
  }), _c('Strength', {
    attrs: {
      "user": _vm.user
    }
  }), (_vm.user.type_user === 2) ? _c('div', [_c('h6', {
    staticClass: "title2 pull-left"
  }, [_vm._v("CỘNG ĐỒNG CỦA GIÁO VIÊN")]), _c('br'), _c('CommunityTeacher')], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "card block-public"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "title2 pull-left"
  }, [_vm._v("CỘNG ĐỒNG")]), _c('p', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "link-color",
    on: {
      "click": _vm.routePathPCList
    }
  }, [_vm._v("Tất cả cộng đồng >")])]), _c('div', {
    staticClass: "clearfix"
  }), _c('Community')], 1)])]), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "card block-activity-mobile"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "title2"
  }, [_vm._v("HOẠT ĐỘNG GẦN ĐÂY")]), _c('div', {
    staticClass: "clearfix"
  }), _c('Activity', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d0321fa","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/index.vue
// module id = 1551
// module chunks = 0